// extracted by mini-css-extract-plugin
export default {"Loader":"Spinner_Loader__LIS6L","load4":"Spinner_load4__HDiBu"};